/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Antsy_Jolly_Camel_ScoopInputs */

const fr_antsy_jolly_camel_scoop = /** @type {(inputs: Antsy_Jolly_Camel_ScoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter les images`)
};

/**

* @param {Antsy_Jolly_Camel_ScoopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const antsy_jolly_camel_scoop = /** @type {((inputs?: Antsy_Jolly_Camel_ScoopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Antsy_Jolly_Camel_ScoopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_antsy_jolly_camel_scoop(inputs)
});